"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
const monotonic_timestamp_1 = __importDefault(require("monotonic-timestamp"));
const withMonotonicTimestamp = (fn) => {
    return fn(monotonic_timestamp_1.default());
};
exports.default = withMonotonicTimestamp;
